<template>
    <div class="fixed w-full z-50">
        <div class="flex md:grid md:grid-cols-3 md:gap-4 px-3 md:px-6 py-3 bg-brand/95 backdrop-blur-md shadow-md border-b border-brand-dark/20 w-full transition-all duration-300">
            <div class="flex-none basis-10 md:basis-auto md:w-full flex items-center justify-start">
                <img v-if="!$app.isMobile" class="h-[14px] md:h-[24px] md:pl-4 drop-shadow-sm" :src="$app.theme.logoUrl || require('../../assets/home-logo.png')" alt="">
                <div v-else class="flex items-center">
                    <el-dropdown trigger="click">
                        <font-awesome-icon :icon="['fas', 'user-circle']" class="user-icon cursor-pointer mt-1" />
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-s-shop" v-if="$app.userInfo.staff_id && $app.userInfo.departments?.some(dep => dep.value === 1) && $app.userInfo.user_role.value === 2">
                                <span @click="updateFullStores()">Cập nhật toàn bộ cửa hàng</span>
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-setting" v-if="$app.userInfo.departments?.some(dep => dep.value === 1) && $app.userInfo.user_role.value === 2">
                                <span @click="openAdminToolsPopup()">Công cụ Admin</span>
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-s-shop" v-if="$app.userInfo.staff_id">
                                <span @click="updateStores()">Cập nhật CH</span>
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-document-checked" v-if="!isFilterValidBillEnabled && ($app.userInfo.user_role.value === 1 || $app.userInfo.departments?.some(dep => dep.value === 3))">
                                <span @click="openHDHLPopup()">Cập nhật HDHL</span>
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-key">
                                <span @click="openChangePasswordPopup()">Đổi mật khẩu</span>
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-lock" v-if="!$app.userInfo.is_active_2fa">
                                <span @click="openSetupPopup()">Setup OTP</span>
                            </el-dropdown-item>
                            <el-dropdown-item class="logout-item"><span class="text-red-500" @click="logOut()"><font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" /> Đăng xuất</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div @click="onOpenFilterPanelPopup"
                class="flex-1 md:flex-none md:w-full flex items-center justify-center cursor-pointer">
                <el-date-picker v-model="$app.selectedDateRange" class="custom-picker" type="daterange" format="dd/MM"
                    range-separator="đến" start-placeholder="Ngày bắt đầu" end-placeholder="Ngày kết thúc"
                    popper-class="custom-prop" readonly>
                </el-date-picker>
            </div>

            <div class="flex-none basis-10 md:basis-auto md:w-full flex justify-end items-center" v-if="$app.userInfo">
                <el-dropdown trigger="click" placement="bottom" :class="{ 'mr-4': !$app.isMobile }">
                    <span class="el-dropdown-link relative block outline-none cursor-pointer group/noti mt-1">
                        <font-awesome-icon :icon="['fas', 'bell']" class="text-white/80 group-hover/noti:text-white text-[20px] transition-colors" />
                        <span v-if="unreadCount > 0" class="absolute top-[3px] right-[2px] bg-red-500 w-2.5 h-2.5 rounded-full border-2 border-brand shadow-[0_0_5px_rgba(239,68,68,0.5)] z-10"></span>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="!p-0 !rounded-xl !border-gray-100 !shadow-[0_10px_40px_rgba(0,0,0,0.15)] w-[320px] overflow-hidden">
                        <div class="px-4 py-3 bg-gray-50/80 border-b border-gray-100 flex items-center justify-between">
                            <span class="font-bold text-gray-800 text-[14px]">Thông báo</span>
                            <span v-if="unreadCount > 0" class="text-xs bg-brand/10 text-brand px-2 py-0.5 rounded-full font-semibold">{{ unreadCount }} mới</span>
                        </div>
                        <div class="max-h-[250px] overflow-y-auto">
                            <div v-if="!notifications || notifications.length === 0" class="px-4 py-8 text-center text-gray-500 text-sm flex flex-col items-center gap-2">
                                <font-awesome-icon :icon="['fas', 'check-double']" class="text-gray-300 text-3xl mb-1" />
                                <span>Tuyệt vời! Bạn không có việc tồn đọng.</span>
                            </div>
                            <div v-else>
                                <div v-for="noti in notifications" :key="noti.id" class="px-4 py-3 border-b border-gray-50 hover:bg-gray-50/80 transition-colors last:border-b-0">
                                    <div class="flex items-start gap-3">
                                        <div class="mt-0.5 flex-shrink-0">
                                            <div v-if="noti.type === 'danger'" class="w-8 h-8 rounded-full bg-red-100 text-red-500 flex items-center justify-center">
                                                <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />
                                            </div>
                                            <div v-else-if="noti.type === 'warning'" class="w-8 h-8 rounded-full bg-yellow-100 text-yellow-600 flex items-center justify-center">
                                                <font-awesome-icon :icon="['fas', 'file-signature']" />
                                            </div>
                                            <div v-else-if="noti.type === 'success'" class="w-8 h-8 rounded-full bg-green-100 text-green-500 flex items-center justify-center">
                                                <font-awesome-icon :icon="['fas', 'check']" />
                                            </div>
                                            <div v-else class="w-8 h-8 rounded-full bg-blue-100 text-blue-500 flex items-center justify-center">
                                                <font-awesome-icon :icon="['fas', 'info']" />
                                            </div>
                                        </div>
                                        <div class="flex-1">
                                            <div class="font-semibold text-gray-800 text-[13px] leading-tight mb-0.5" :class="{'text-red-600': noti.type === 'danger'}">{{ noti.title }}</div>
                                            <div class="text-[13px] text-gray-600 leading-snug">{{ noti.message }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown trigger="click" v-if="!$app.isMobile">
                    <span class="cursor-pointer text-white/90 font-semibold hover:text-white transition-colors">
                        {{ $app.userInfo.name }}<i class="el-icon-arrow-down el-icon--right ml-1"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-s-shop"
                            v-if="$app.userInfo.staff_id && $app.userInfo.departments?.some(dep => dep.value === 1) && $app.userInfo.user_role.value === 2">
                            <span @click="updateFullStores()">Cập nhật toàn bộ cửa hàng</span>
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-setting"
                            v-if="$app.userInfo.departments?.some(dep => dep.value === 1) && $app.userInfo.user_role.value === 2">
                            <span @click="openAdminToolsPopup()">Công cụ Admin</span>
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-s-shop" v-if="$app.userInfo.staff_id">
                            <span @click="updateStores()">Cập nhật CH</span>
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-document-checked" v-if="!isFilterValidBillEnabled && ($app.userInfo.user_role.value === 1 || $app.userInfo.departments?.some(dep => dep.value === 3))">
                            <span @click="openHDHLPopup()">Cập nhật HDHL</span>
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-key">
                            <span @click="openChangePasswordPopup()">Đổi mật khẩu</span>
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-lock" v-if="!$app.userInfo.is_active_2fa">
                            <span @click="openSetupPopup()">Setup OTP</span>
                        </el-dropdown-item>
                        <el-dropdown-item class="logout-item"><span class="text-red-500"
                                @click="logOut()"><font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" /> Đăng
                                xuất</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <OtpSetup v-if="isShowOtpPopup" :isShow="isShowOtpPopup" @closed="isShowOtpPopup = false" />
        <FilterPanelPopup v-if="isShowFilterPanelPopup" :isShow="isShowFilterPanelPopup"
            @closed="onClosedFilterPanelPopup" />
        <AdminToolsPopup v-if="isShowAdminToolsPopup" :isShow="isShowAdminToolsPopup" @closed="isShowAdminToolsPopup = false" />
        <UpdateValidBillsPopup v-if="isShowHDHLPopup" :isShow="isShowHDHLPopup" @closed="isShowHDHLPopup = false" />
        <ChangePasswordPopup v-if="isShowChangePasswordPopup" :isShow="isShowChangePasswordPopup" @closed="isShowChangePasswordPopup = false" />
    </div>
</template>

<script>
import OtpSetup from '../popup/OtpSetup.vue';
import FilterPanelPopup from '../popup/FilterPanelPopup.vue';
import AdminToolsPopup from '../popup/AdminToolsPopup.vue';
import UpdateValidBillsPopup from '../popup/UpdateValidBillsPopup.vue';
import ChangePasswordPopup from '../popup/ChangePasswordPopup.vue';
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {
        OtpSetup,
        FilterPanelPopup,
        AdminToolsPopup,
        UpdateValidBillsPopup,
        ChangePasswordPopup
    },
    data() {
        return {
            qrCode: '',
            isShowOtpPopup: false,
            isShowAdminToolsPopup: false,
            isShowHDHLPopup: false,
            isShowChangePasswordPopup: false,
            userdata: null,
            isShowFilterPanelPopup: false,
            notifications: [],
            unreadCount: 0,
            isFilterValidBillEnabled: false
        };
    },
    computed: {

    },
    watch: {
        '$app.userInfo.access_token': {
            handler(newToken) {
                if (newToken) {
                    this.fetchNotifications();
                    this.fetchAppConfig();
                }
            },
            immediate: true
        }
    },

    created() {
    },

    mounted() {
        console.log(this.$app.isMobile)
        if (this.$app.userInfo?.access_token) {
            this.fetchNotifications();
            this.fetchAppConfig();
        }
        this.$app.on('reloadData', () => {
             this.fetchNotifications();
        });
    },

    methods: {
        async fetchAppConfig() {
            try {
                const token = this.$app.token || this.$app.userInfo?.access_token || localStorage.getItem('uToken')?.replace(/"/g, '');
                if (!token) return;
                const res = await this.$axios.get(`${API_URL}/bills/config`, {
                    headers: { 'X-Authorization': `Bearer ${token}` }
                });
                if (res.data && res.data.success) {
                    this.isFilterValidBillEnabled = res.data.filterValidBill;
                }
            } catch (err) {
                console.error("Failed to fetch app config:", err);
            }
        },
        async fetchNotifications(retry = 0) {
            try {
                // Đảm bảo token đã sẵn sàng (trường hợp vừa login xong Vuex/Pinia chưa kịp build token)
                const token = this.$app.token || this.$app.userInfo?.access_token || localStorage.getItem('uToken')?.replace(/"/g, '');
                
                if (!token) {
                    if (retry < 2) {
                        setTimeout(() => this.fetchNotifications(retry + 1), 300);
                    }
                    return;
                }

                const res = await this.$axios.get(`${API_URL}/bills/notifications`, {
                    headers: {
                        'X-Authorization': `Bearer ${token}`
                    }
                });
                
                if (res.data && res.data.success) {
                    this.notifications = res.data.notifications || [];
                    this.unreadCount = res.data.totalUnread || 0;
                }
            } catch (error) {
                // Nếu bị 401 lúc vừa login, thử lại 1 lần sau 500ms để chờ token set xong
                if (error.response?.status === 401 && retry < 1) {
                    setTimeout(() => this.fetchNotifications(retry + 1), 500);
                } else {
                    console.error("Failed to fetch notifications:", error);
                }
            }
        },

        onClosedFilterPanelPopup(e) {
            if (e) {
                this.$app.emit('reloadData')
            }
            this.isShowFilterPanelPopup = false
            this.$root.$emit('closeFilterPanelPopup')
        },

        onOpenFilterPanelPopup() {
            this.isShowFilterPanelPopup = true
        },

        openAdminToolsPopup() {
            this.isShowAdminToolsPopup = true
        },

        openHDHLPopup() {
            this.isShowHDHLPopup = true
        },

        openSetupPopup() {
            this.isShowOtpPopup = true
        },

        openChangePasswordPopup() {
            this.isShowChangePasswordPopup = true
        },

        logOut() {
            this.$emit('logout')
        },
        async updateStores() {
            try {
                this.isLoading = true;

                const res = await this.$axios.post(`${API_URL}/authuserslog/update-stores`, {},
                    {
                        headers: {
                            'X-Authorization': `Bearer ${this.$app.userInfo.access_token}`, // token lấy từ login
                        }
                    });

                if (res.data.success) {
                    this.$app.userInfo.stores = res.data.stores; // cập nhật lại UI
                    this.$notify.success({
                        title: 'Cập nhật thành công',
                        message: res.data.message
                    });
                } else {
                    this.$notify.error({
                        title: 'Cập nhật thất bại',
                        message: res.data.message
                    });
                }
            } catch (e) {
                console.error(e);
                this.$notify.error({
                    title: 'Cập nhật thất bại',
                    message: 'Đã xảy ra lỗi trong quá trình cập nhật cửa hàng.'
                });
            } finally {
                this.isLoading = false;
            }
        },

        async updateFullStores() {
            try {
                this.isLoading = true;

                const res = await this.$axios.get(
                    `${API_URL}/stores/import`,
                    {
                        headers: {
                            'X-Authorization': `Bearer ${this.$app.userInfo.access_token}`
                        }
                    }
                );

                console.log("Kết quả cập nhật:", res);

                this.$notify.success({
                    title: 'Cập nhật thành công',
                    message: res.data.message
                });
            } catch (error) {
                console.error("Lỗi cập nhật:", error);

                this.$notify.error({
                    title: 'Cập nhật thất bại',
                    message: error
                });
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.el-icon-arrow-down {
    font-size: 12px;
}

.demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
}

::v-deep(.logout-item:hover) {
    background-color: rgb(253, 204, 204);
}

.user-icon {
    color: rgba(255, 255, 255, 0.9);
    font-size: 24px;
}
.btnNoti{
    background-color: rgba(255, 255, 255, 0);
    border: none;
    padding: 0;
    font-size: 16px;
}
.btnNoti:focus,.btnNoti:hover{
    background-color: rgba(255, 255, 255, 0) !important
}
</style>